import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { SUPPORTED_LANGUAGES, useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";

export default function Navbar() {
  const { isAuthed, logout, email } = useAuth();
  const { language, setLanguage, t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const inAdmin = location.pathname.startsWith("/admin");

  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex min-w-0 items-center gap-2 group" data-testid="brand-link">
          <img
            src="/icon-192.png"
            alt="LunchSpot logo"
            className="h-9 w-9 rounded-xl shadow-sm transition-transform group-hover:scale-105"
          />
          <div className="min-w-0 leading-none">
            <div className="font-heading font-bold text-lg tracking-tight">LunchSpot</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#9A9E8D]">{t.nearYou}</div>
          </div>
        </Link>

        <nav className="flex shrink-0 items-center gap-2 sm:gap-3">
          <div className="inline-flex rounded-full border border-[rgba(61,64,53,0.08)] bg-white p-1 shadow-sm" aria-label={t.languageLabel} data-testid="language-toggle">
            {SUPPORTED_LANGUAGES.map((code) => (
              <button
                key={code}
                type="button"
                onClick={() => setLanguage(code)}
                aria-pressed={language === code}
                data-testid={`language-${code}`}
                className={`min-w-9 rounded-full px-2.5 py-1.5 text-xs font-bold uppercase tracking-[0.12em] transition sm:min-w-10 sm:px-3 ${language === code ? "bg-[#3D4035] text-[#F7F5F0]" : "text-[#6A6F5C] hover:text-[#E07A5F]"}`}
              >
                {code}
              </button>
            ))}
          </div>
          {isAuthed ? (
            <>
              <Link to="/admin" data-testid="nav-admin-link">
                <Button variant="outline" size="sm" className="rounded-full">
                  <ShieldCheck size={16} className="mr-1.5" /> {t.admin}
                </Button>
              </Link>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => { logout(); navigate("/"); }}
                data-testid="nav-logout"
                title={email}
              >
                <LogOut size={16} />
              </Button>
            </>
          ) : (
            <Link to="/admin/login" data-testid="nav-login-link">
              <Button variant="outline" size="sm" className="rounded-full px-3 sm:px-4">{t.admin}</Button>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
